export default "__VITE_ASSET__CBG1_zRd__"